export const name = "SHA256";
export const summary = `Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-256 algorithm.`;
export const reference = `
## SHA256

Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-256 algorithm.

\`\`\`
SHA256(input)
\`\`\`

### Description

Computes the hash of the input using the SHA-256 algorithm. The input can either be\`STRING\` or \`BYTES\`. The string version treats the input as an array of bytes.

This function returns 32 bytes.


### Return type

\`BYTES\`


### Example



\`\`\`
SELECT SHA256("Hello World") as sha256;
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/hash_functions
`;
